import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NudgeState {
  dismiss: (nudgeId: string) => void;
  dismissedNudges: Array<string>;
  isDismissed: (nudgeId: string) => boolean;
  resetAll: () => void;
}

export const useNudgeStore = create<NudgeState>()(
  persist(
    (set, get) => ({
      dismiss: (nudgeId: string) => {
        const { dismissedNudges } = get();
        if (!dismissedNudges.includes(nudgeId)) {
          set({ dismissedNudges: [...dismissedNudges, nudgeId] });
        }
      },
      dismissedNudges: [],
      isDismissed: (nudgeId: string) => {
        return get().dismissedNudges.includes(nudgeId);
      },
      resetAll: () => {
        set({ dismissedNudges: [] });
      },
    }),
    {
      name: 'nudge-store',
    },
  ),
);
